import ProjectsPage, { handle } from '@modules/professional/page/ProjectsPage';
import { loader } from '@modules/professional/page/loaders/projects-page-loader.server';

export { loader, handle };
export default ProjectsPage;
